export default __webpack_public_path__ + "static/media/photo-1546539782-6fc531453083.a7c849be.jpeg";